module.exports = __webpack_public_path__ + "img/report.8d80d743.png";